
import { Component } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { Yii } from 'libraries/interfaces/Yii';
import { NotificationType } from 'libraries/interfaces/INotification';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';


export interface IDeleteValidationOutput {
    doDelete: boolean;
}

enum WORDING {
    title = "title",
    cancel = "cancel",
    delete = "delete",
    deleteConfirmationMessage = "deleteConfirmationMessage",
    close = "close",
}

@Component({
    selector: 'delete-confirmation-dialog',
    template: `
        <card [@.disabled]="true">
            <div class="card-header-content" mat-dialog-title>
                <h1>{{ wording.title }}</h1>
                <div class="btn-container">
                    <btn [type]="btnStyles.actionHeaderLink"
                        [label]="wording.close"
                        (click)="close()"></btn>
                </div>
            </div>
            <div class="card-body-content" mat-dialog-content>
                <notification [type]="notificationType.Warning">
                    {{ wording.deleteConfirmationMessage }}
                </notification>
            </div>
            <div class="card-footer-content">
                <btn [type]="btnStyles.actionDo"
                    [label]="wording.delete"
                    (click)="submit()">
                </btn>
                <btn [type]="btnStyles.actionLinkUndo"
                    [label]="wording.cancel"
                    (click)="close()"></btn>
            </div>
        </card>
    `,
    styles: [`
        notification{
            margin-bottom: 1rem;
        }

        .title-container{
            display: flex;
        }

        h1,
        .btn-container{
            flex: 1;
        }

        .btn-container{
            flex-grow: 0;
        }

        .card-footer-content{
            margin: 0 0.75rem;
        }
    `]
})

export class DeleteConfirmationDialogComponent {

    public wording: { [key in WORDING]: string } = {
        title: Yii.t('wui-quotation-js', "Confirmation de la suppression"),
        deleteConfirmationMessage: Yii.t('wui-quotation-js', "La suppression de cette ligne entrainera la perte des valeurs saisies"),
        delete: Yii.t('wui-quotation-js', "Supprimer la ligne"),
        cancel: Yii.t('wui-quotation-js', "Annuler"),
        close: Yii.t('wui-shared-js', "Fermer"),
    };

    public btnStyles: typeof BtnStyleTypes = BtnStyleTypes;

    public notificationType: typeof NotificationType = NotificationType;

    constructor(
        private readonly dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
    ) { }

    public close(): void {
        this.dialogRef.close();
    }

    public submit(): void {
        this.dialogRef.close({
            doDelete: true
        });
    }
}
